import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../types';
import { defaultFilters } from '../../../../../views/Entities/Entities';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/entities/')({
  validateSearch: zodValidator(withDefaults(schema.ENTITIES, defaultFilters, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ENTITIES });
    context.validatePermissions({ isAllowed, preload });
  },
});
